var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomCardSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#0089F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 40.6955C33.2211 40.6955 40.696 33.2206 40.696 23.9999C40.696 14.7791 33.2211 7.3042 24.0003 7.3042C14.7796 7.3042 7.30469 14.7791 7.30469 23.9999C7.30469 33.2206 14.7796 40.6955 24.0003 40.6955Z",
    fill: "#0089F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1745 29.8432H15.6528C14.2696 29.8432 13.1484 28.7221 13.1484 27.3389V18.1562H25.6702C27.0534 18.1562 28.1745 19.2774 28.1745 20.6606V29.8432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8524 29.8432L29.8438 26.5041V21.4954L34.8524 18.1562V29.8432Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomCardSvg);
export default __webpack_public_path__ + "static/media/ZoomCardSvg.a324624a2a187c01780f2354b40806bb.svg";
export { ForwardRef as ReactComponent };